














































































































































































import { getModule } from 'vuex-module-decorators'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Convenio } from '@/types/_'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import moment from 'moment'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import timeGrid from '@fullcalendar/timegrid'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import EventBus from '@/plugins/EventBus'
import tippy from 'tippy.js'

@Component({ components: { FullCalendar } })
export default class ModalSurgeryGrid extends Vue {
  @Prop() visible: boolean

  $refs!: {}

  @Emit('close')
  closeModal() {}

  @Emit('esc')
  escClick() {}

  show: boolean = false
  calendarLoading = false
  currentFilteredDate = ''

  @Watch('getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto1')
  onFirstExpectedDateChange(date) {
    const formattedDate = moment(date).format('YYYY-MM-DD')

    if (date) {
      this.findRoomReservation(formattedDate)
        .then((response) => {
          this.currentFilteredDate = formattedDate
        })
    }
  }

  @Watch('visible')
  async onVisibilityChange(visible: boolean) {
    this.show = visible
  }

  secondStepperRules: any = {
    opcaoDataPrevisto1: [],
  }

  mounted() {
    const {
      opcaoDataPrevisto1,
    } = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario

    if (opcaoDataPrevisto1 && opcaoDataPrevisto1.obrigatorio) {
      this.secondStepperRules.opcaoDataPrevisto1.push(v => !!v || 'Campo obrigatório')
    }
  }

  close() {
    this.$emit('close')
  }

  esc() {
    this.$emit('esc')
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  validateDate(date1, date2): Boolean {
    if ([null, undefined, ''].includes(date1) || [null, undefined, ''].includes(date2)) {
      return false
    }
    if (new Date(date1).toISOString() === new Date(date2).toISOString()) {
      return true
    }


    return false
  }

  validateHours(date1, date2): Boolean {
    const diff = Math.abs(new Date(date1).getTime() - new Date(date2).getTime())
    const hours = diff / (1000 * 3600)
    return hours < 1
  }

  get getTemplate() {
    return this.getSolicitacaoCirurgiaStore.currentTemplate.formulario
  }

  calendarOptions: any = {
    timeZone: 'UTC',
    height: 350,
    locale: ptBrLocale,
    plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin, timeGrid],
    initialView: 'resourceTimeline',
    aspectRatio: 1.5,
    headerToolbar: {
      left: 'today,prev,next',
      center: 'title',
      right: '',
    },
    slotLabelFormat: { hour12: false, hour: '2-digit', minute: '2-digit' },
    slotDuration: '00:30:00',
    editable: true,
    droppable: false,
    selectable: true,
    resourceAreaHeaderContent: 'Salas',
    resourceOrder: 'title',
    resources: this.getReservaSalasResources,
    eventDidMount: this.eventRender,
    eventDrop: this.handleEventDrop,
    customButtons: {
      prev: {
        text: 'Anterior',
        click: () => {
          const { calendar }: any = this.$refs

          const currentDate = moment(calendar.getApi().getDate()).format('YYYY-MM-DD')

          this.reloadCalendarInfo(currentDate)
            .then((response) => {
            })
        },
      },
      next: {
        text: 'Próximo',
        click: () => {
          const { calendar }: any = this.$refs
          calendar.getApi().next()
          const currentDate = moment(calendar.getApi().getDate()).add('day', 1).format('YYYY-MM-DD')


          this.reloadCalendarInfo(currentDate)
            .then((response) => {
            })
        },
      },
      today: {
        text: 'Hoje',
        click: () => {
          const { calendar }: any = this.$refs
          calendar.getApi().today()
          const currentDate = moment().format('YYYY-MM-DD')

          this.reloadCalendarInfo(currentDate)
            .then((response) => {
            })
        },
      },
    },
  }

  get getReservaSalasResources() {
    return this.getReservaSalaStore.reservaSalasResource
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }


  handleEventDrop(eventoInfo) {
    eventoInfo.revert()
  }

  eventRender(info: any) {
    if (info.event.extendedProps.dataAgendamentoVirtual) {
      const span = document.createElement('span')
      span.setAttribute('class', 'fa fa-building white--text ml-2')
      info.el.appendChild(span)
    }

    if (info.event.extendedProps.description) {
      tippy(info.el, {
        content: info.event.extendedProps.description,
        placement: 'top',
      })
    }
  }

  async reloadCalendarInfo(date = moment().format('YYYY-MM-DD')) {
    this.calendarLoading = true

    const filteredDate = date

    const params = {
      solicitacaoId: this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.id,
      data: filteredDate,
      tempoCirurgia: this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.tempoCirurgia,
      isDoctor: true,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      calendar.getApi().gotoDate(filteredDate)
      calendar.getApi().render()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    this.currentFilteredDate = filteredDate
    this.calendarLoading = false
  }

  gradeMedica(prop) {
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      const response = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop]
      // eslint-disable-next-line
      if (response) return response['gradeMedica']
    }

    return false
  }

  opcaoHabilitado(prop1, prop2) {
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      const response = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop1]
        && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop1].campos
        && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop1].campos[prop2]
      return response
    }

    return false
  }

  campoHabilitado(prop: string) {
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      const response = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop]

      // eslint-disable-next-line
      if (response) return response['habilitado']
    }

    return false
  }

  canEnableFieldForEditModelMode(fieldName: string) {
    const fields: string[] = [
      'justificativa',
      'cids',
      'procedimentosAssociados',
      'opmes',
      'tempoCirurgia',
      'nomeCirurgia',
      'equipamentos',
    ]

    return fields.includes(fieldName)
  }

  async findRoomReservation(date) {
    this.calendarLoading = true

    const params = {
      solicitacaoId: this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.id,
      data: date,
      tempoCirurgia: this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.tempoCirurgia,
      isDoctor: true,
    }

    const roomReservationAPIResponse = await this.getReservaSalaStore.getReservaSalas(params)


    if (roomReservationAPIResponse.success) {
      const { calendar }: any = this.$refs

      await calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().render()
      await calendar.getApi().gotoDate(date)
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: roomReservationAPIResponse.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }


    this.calendarLoading = false
  }

  get textFieldProps1() {
    const date1 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto1
    const date2 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto2
    const date3 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto3
    const rules: any[] = []
    rules.push(v => (!this.validateDate(date1, date2) && !this.validateDate(date1, date3)) || 'Datas e horários iguais não são permitidos')
    rules.push(v => (!this.validateHours(date1, date2) && !this.validateHours(date1, date3)) || 'É necessário uma diferência de no mínimo 1 hora entre os horários')

    if (this.getTemplate.opcaoDataPrevisto1.obrigatorio) {
      rules.push(v => !!v || 'Campo obrigatório.')
    }

    return { appendIcon: 'event', rules }
  }

  get textFieldProps2() {
    const date1 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto1
    const date2 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto2
    const date3 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto3
    const rules: any[] = []
    rules.push(v => (!this.validateDate(date1, date2) && !this.validateDate(date2, date3)) || 'Datas e horários iguais não são permitidos')
    rules.push(v => (!this.validateHours(date1, date2) && !this.validateHours(date2, date3)) || 'É necessário uma diferência de no mínimo 1 hora entre os horários')

    if (this.getTemplate.opcaoDataPrevisto2 && this.getTemplate.opcaoDataPrevisto2.obrigatorio) {
      rules.push(v => !!v || 'Campo obrigatório.')
    }

    return { appendIcon: 'event', rules }
  }

  get textFieldProps3() {
    const date1 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto1
    const date2 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto2
    const date3 = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto3
    const rules: any[] = []
    rules.push(v => (!this.validateDate(date1, date3) && !this.validateDate(date2, date3)) || 'Datas e horários iguais não são permitidos')
    rules.push(v => (!this.validateHours(date1, date3) && !this.validateHours(date2, date3)) || 'É necessário uma diferência de no mínimo 1 hora entre os horários')

    if (this.getTemplate.opcaoDataPrevisto3 && this.getTemplate.opcaoDataPrevisto3.obrigatorio) {
      rules.push(v => !!v || 'Campo obrigatório.')
    }
    return { appendIcon: 'event', rules }
  }

  get datePickerProps1() {
    const variation = ['Urgencia', 'EletivoSemAutorizacao', 'Emergencia'].includes(this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.carater) ? 86400000 : 0
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now() - variation).toISOString(),
      max: this.prazoParaTriagem,
      'data-cy': 'grid-opcaoDataPrevisto1-date',
    }
  }

  get surgeryHasOPME() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.grupoDeOpme && this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.grupoDeOpme.opmes.length > 0
  }

  get prazoParaTriagem() {
    return this.convenioDaSolicitacao && this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento && this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento > 0
      ? moment().add(this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento, 'days').format('YYYY-MM-DD')
      : moment().add(10, 'years').format('YYYY-MM-DD')
  }


  get convenioDaSolicitacao() {
    let conv = this.getSolicitacaoCirurgiaStore.convenios.find((convenio: Convenio) => convenio.id === this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.convenioId)
    if (!conv) {
      conv = {
        id: '',
        nome: '',
        particular: false,
        status: '',
        convenioUtilizaFluxoDePreviaCirurgica: false,
        prazoEmDiasParaTriagem: 0,
        prazoMaximoEmDiasParaAgendamento: 0,
      }
    }
    return conv
  }


  get timePickerProps1() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'grid-opcaoDataPrevisto1-time',
      allowedMinutes: m => m % 15 === 0,
    }
  }

  get datePickerProps2() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
      max: this.prazoParaTriagem,
      'data-cy': 'grid-opcaoDataPrevisto2-date',
    }
  }

  get timePickerProps2() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'grid-opcaoDataPrevisto2-time',
      allowedMinutes: m => m % 15 === 0,
    }
  }

  get datePickerProps3() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
      max: this.prazoParaTriagem,
      'data-cy': 'grid-opcaoDataPrevisto3-date',
    }
  }

  get timePickerProps3() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'grid-opcaoDataPrevisto3-time',
      allowedMinutes: m => m % 15 === 0,
    }
  }
}
